import texts from './translationTexts-engb.json';

export const translations = {
  [texts.language]: texts,
};

export type translationsType = typeof texts.translations;
